import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';

// Generic bulk-action modal shared by every UG review panel — PG's own
// bulk verify (TeacherDashboard/ViewLogbooks.js) applies one form to a
// checked subset of entries via Promise.all of the existing per-entry
// endpoint; this is the same idea, just with the form body and the
// per-entry submit call left to the caller since each UG module's review
// shape (status+feedback vs domain-scored assessment) and endpoint
// (single id vs studentId/moduleKey pair) differ.
const BulkVerifyModal = ({
  title,
  items,
  getId,
  renderItemLabel,
  renderForm,
  isValid,
  onConfirm,
  onClose
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [formState, setFormState] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const toggleSelect = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const selectAll = () => {
    setSelectedIds(prev => prev.length === items.length ? [] : items.map(getId));
  };

  const handleSubmit = async () => {
    if (selectedIds.length === 0) {
      alert('Please select at least one entry.');
      return;
    }
    if (isValid && !isValid(formState)) {
      alert('Please complete the form before submitting.');
      return;
    }
    try {
      setSubmitting(true);
      const selectedItems = items.filter(item => selectedIds.includes(getId(item)));
      await onConfirm(selectedItems, formState);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="ugtr-modal-overlay" onClick={() => !submitting && onClose()}>
      <div className="ugtr-modal ugtr-bulk-modal" onClick={e => e.stopPropagation()}>
        <div className="ugtr-modal-head">
          <h3>{title}</h3>
          <FaTimes onClick={() => !submitting && onClose()} />
        </div>

        <div className="ugtr-bulk-select-header">
          <button type="button" className="ugtr-bulk-select-all" onClick={selectAll}>
            {selectedIds.length === items.length ? 'Deselect all' : 'Select all'}
          </button>
          <span className="ugtr-bulk-count">{selectedIds.length} of {items.length} selected</span>
        </div>

        <div className="ugtr-bulk-list">
          {items.map(item => {
            const id = getId(item);
            const checked = selectedIds.includes(id);
            return (
              <div
                key={id}
                className={`ugtr-bulk-item ${checked ? 'ugtr-bulk-item-selected' : ''}`}
                onClick={() => toggleSelect(id)}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggleSelect(id)}
                  onClick={e => e.stopPropagation()}
                />
                <div className="ugtr-bulk-item-info">{renderItemLabel(item)}</div>
              </div>
            );
          })}
        </div>

        <div className="ugtr-bulk-form">
          {renderForm(formState, setFormState)}
        </div>

        <div className="ugtr-modal-actions">
          <button className="ugtr-btn-secondary" onClick={onClose} disabled={submitting}>Cancel</button>
          <button className="ugtr-btn-primary" onClick={handleSubmit} disabled={submitting || selectedIds.length === 0}>
            {submitting ? 'Submitting...' : `Verify ${selectedIds.length || ''} ${selectedIds.length === 1 ? 'entry' : 'entries'}`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkVerifyModal;
